import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './session/auth.guard';
import { AuthFalseGuard } from './session/authfalse.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./views/home/home.module').then(m => m.HomePageModule),
    canActivate: [AuthFalseGuard],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'app-config',
    loadChildren: () => import('./views/app-config/app-config.module').then(m => m.AppConfigPageModule),
    canActivate: [AuthFalseGuard],
  },
  {
    path: 'app-config/:modulo/:codigo/:sistema/:idioma',
    loadChildren: './views/app-config/app-config.module#AppConfigPageModule',
    canActivate: [AuthFalseGuard],
  },
  {
    path: 'app-edit',
    loadChildren: () => import('./views/app-edit/app-edit.module').then(m => m.AppEditPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'app-salir',
    loadChildren: () => import('./views/app-salir/app-salir.module').then(m => m.AppSalirPageModule),
    canActivate: [AuthGuard],
  },
  // CAJEROS DE AGUA
  {
    path: 'atwater',
    loadChildren: () => import('./views/cajeros/atwater/atwater.module').then(m => m.AtwaterPageModule),
    canActivate: [AuthGuard],
    /*data: {
      
    }*/
  },
  // RECYCLA
  {
    path: 'recycla',
    loadChildren: () => import('./views/reciclaje/recycla/recycla.module').then(m => m.RecyclaPageModule),
    canActivate: [AuthGuard]
  },
  // CAJERO TRANSACCIONAL
  {
    path: 'automatico',
    loadChildren: () => import('./views/cajeros/automatico/automatico.module').then(m => m.AutomaticoPageModule),
    canActivate: [AuthGuard]
  },
  // REFILL VENDING
  {
    path: 'refillvending',
    loadChildren: () => import('./views/refill/refillvending/refillvending.module').then(m => m.RefillvendingPageModule),
    canActivate: [AuthGuard]
  },
  // LINEA DE LLENADO SEMI AUTOMATICA
  {
    path: 'lineallenado',
    loadChildren: () => import('./views/lineallenado/lineallenado/lineallenado.module').then( m => m.LineallenadoPageModule),
    canActivate: [AuthGuard]
  }, 
  // PUBLIAQUA
  {
    path: 'tv',
    loadChildren: () => import('./views/publiaqua/tv/tv.module').then( m => m.TvPageModule),
    canActivate: [AuthGuard]
  },
  // VENDING DE ASEO
  {
    path: 'at-cleaning',
    loadChildren: () => import('./views/vending/at-cleaning/at-cleaning.module').then( m => m.AtCleaningPageModule),
    canActivate: [AuthGuard]
  },
  // TIENDA DE AGUA
  {
    path: 'watershop-central',
    loadChildren: () => import('./views/watershop/watershop-central/watershop-central.module').then( m => m.WatershopCentralPageModule),
    canActivate: [AuthGuard]
  },
  // VENDING 
  {
    path: 'machine',
    loadChildren: () => import('./views/vending/machine/machine.module').then( m => m.MachinePageModule),
    canActivate: [AuthGuard]
  },
  // VENDING DE ACEITE
  {
    path: 'at-oil',
    loadChildren: () => import('./views/vending/at-oil/at-oil.module').then( m => m.AtOilPageModule),
    canActivate: [AuthGuard]
  },
  // VENDING DE ACEITE
  {
    path: 'at-milk',
    loadChildren: () => import('./views/vending/at-milk/at-milk.module').then( m => m.AtMilkPageModule),
    canActivate: [AuthGuard]
  },
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
